module.exports = __webpack_public_path__ + "static/media/conjuntos.46e26eeb.jpg";